/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from "../firebase";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { mostrarError } from "../utils/Alertas";

interface Viaje {
    id: string;
    destino: string;
}

const ViajesCompletados: React.FC = () => {
    const [viajesCompletados, setViajesCompletados] = useState<Viaje[]>([]);

    const mostrarViajesCompletados = async () => {
        try {
            const viajesCompletadosSnapshot = await getDocs(collection(db, 'ViajesCompletados'));
            const viajesCompletadosList: Viaje[] = [];
            viajesCompletadosSnapshot.forEach(doc => {
                viajesCompletadosList.push({ id: doc.id, destino: doc.data().destino });
            });
            setViajesCompletados(viajesCompletadosList);
        } catch (error) {
            console.error('Error obteniendo los viajes completados: ', error);
            mostrarError('Error obteniendo los viajes completados.');
        }
    };

    useEffect(() => {
        mostrarViajesCompletados();
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="text-center">
                    <h2 className="pb-2">Viajes Completados</h2>
                </div>

                <div className="container-fluid content">
                    {viajesCompletados.length > 0 && <div className="list" id="viajesCompletadosList">
                        <ul id="comidaCompletadasItems">
                            {viajesCompletados.map((item) => (
                                <li key={item.id} className="idea-item">{item.destino}</li>
                            ))}
                        </ul>
                    </div>}
                </div>
            </div>
        </Fragment>
    );
};

export default ViajesCompletados;
